// API szolgáltatás a backend kommunikációhoz
export class ApiService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    // Metadata lekérése (beadvány típusonként megjelenítendő mezők)
    async fetchMetadata() {
        try {
            const response = await fetch(`${this.apiUrl}/metadata`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error fetching metadata:", error);
            throw error;
        }
    }

    // Beadványok lekérése keresési paraméterekkel
    async fetchRecords(searchParams = {}, page = 1, pageSize = 10) {
        let url = `${this.apiUrl}/records?page=${page}&page_size=${pageSize}`;

        for (const key in searchParams) {
            if (searchParams[key]) {
                url += `&${key}=${encodeURIComponent(searchParams[key])}`;
            }
        }

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error fetching records:", error);
            throw error;
        }
    }

    // Egy konkrét beadvány részleteinek lekérése
    async fetchRecordDetail(recordId) {
        try {
            const response = await fetch(`${this.apiUrl}/record/${recordId}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error fetching record details:", error);
            throw error;
        }
    }
}
